import { PlatformApproveQueue } from "@lumora/ui";
import { usePlatformApproveQueueVm } from "./platformViewModels.js";
import { PlatformPageHeader } from "./PlatformPageHeader.js";

export function PlatformApprovalsPage() {
  const queueVm = usePlatformApproveQueueVm();

  return (
    <div className="site-platform">
      <PlatformPageHeader
        title="Approvals"
        lead="Sandbox publish requests. Approving unlocks live publish for that site."
      />
      <PlatformApproveQueue vm={queueVm} />
    </div>
  );
}
